import * as styles from "./AutocompleteClear.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Autocomplete as BaseAutocomplete } from "@base-ui/react/autocomplete";
import { Icon } from "@frontend/components/atoms/Icon";

import type { AutocompleteClearProps } from "./Autocomplete.types";

export function AutocompleteClear({
  className,
  children,
  ...props
}: AutocompleteClearProps): JSX.Element {
  return (
    <BaseAutocomplete.Clear
      data-slot="autocomplete-clear"
      className={clsx(styles.clear, className)}
      {...props}
    >
      {children ?? <Icon name="X" size="sm" />}
    </BaseAutocomplete.Clear>
  );
}
